/**
 * 故障提交报告暂存
 */

const prefix = '/dseWeb'
export default [
  // 根据ID查询草稿记录
  {
    name: 'selectByErrorId',
    url: `${prefix}/v1/op/errorSubmitRecord/selectByErrorId`,
    method: 'get'
  },
  // 插入故障草稿
  {
    name: 'draftErrorSubmitRecord',
    url: `${prefix}/v1/op/errorSubmitRecord/draft`,
    method: 'post'
  }
]
